import React, { useContext, useState } from 'react';
import { GroupChartList } from '../../../../components/charts/ChartList';
import { TimeRangeSelect } from '../../../../components/forms';
import { TimeRangeNavigator, ButtonIcon } from '../../../../components/ui';
import { NotebookContext } from '../../../../context/NotebookContext';
import TimeNavigatorBar from '../../../../components/forms/TimeNavigatorBar';
import EmptyState from './EmptyState';
import SummaryCard from '../../../../components/SummaryCard';
import { ItemType } from '../../../../components/SummaryCard/types';

interface GroupDataProps {
  group: {
    subjects: {
      id: string;
      name: string;
      slug: string;
    }[];
    trackers: {
      id: string;
      name: string;
      slug: string;
      type: TrackerType;
      subjects: {
        id: string;
        name: string;
        slug: string;
      }[];
    }[];
  };
  setActiveTab: (value: 'SETTINGS') => void;
}

const GroupData: React.FC<GroupDataProps> = ({ group, setActiveTab }) => {
  const { notebook } = useContext(NotebookContext);
  const initialShowType = 'TRACKERS';
  const [showType, setShowType] = useState<'SUBJECTS' | 'TRACKERS'>(initialShowType);

  return (
    <>
      {group.trackers.length > 0 && (
        <>
          <div className="flex justify-between">
            <TimeNavigatorBar />

            <div className="flex">
              <button
                className={`w2 h2 bg-light-gray br-100 flex items-center justify-center f7 fw5 mr2 ${
                  showType === 'SUBJECTS' ? 'bg-blue white' : 'bg-near-white blue'
                }`}
                onClick={() => setShowType('SUBJECTS')}
                data-testid="subject-toggle"
              >
                S
              </button>

              <button
                className={`w2 h2 bg-light-gray br-100 flex items-center justify-center f7 fw5 ${
                  showType === 'TRACKERS' ? 'bg-blue white' : 'bg-near-white blue'
                }`}
                onClick={() => setShowType('TRACKERS')}
                data-testid="tracker-toggle"
              >
                T
              </button>
            </div>
          </div>

          {showType === 'TRACKERS' &&
            group.trackers.map(tracker => {
              return (
                <GroupChartList
                  tracker={tracker}
                  subjects={group.subjects}
                  key={tracker.id}
                  notebookId={notebook.id}
                />
              );
            })}

          {showType === 'SUBJECTS' &&
            group.subjects.map(subject => {
              const item = {
                ...subject,
                trackers: group.trackers,
                type: 'SUBJECT' as ItemType
              };
              return <SummaryCard key={item.id} item={item} />;
            })}
        </>
      )}

      {group.trackers.length === 0 && <EmptyState setActiveTab={setActiveTab} />}
    </>
  );
};

export default GroupData;
